import { render, staticRenderFns } from "./RevisionTimeline.vue?vue&type=template&id=6004064e"
import script from "./RevisionTimeline.vue?vue&type=script&lang=js"
export * from "./RevisionTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports